import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import PageHeader from 'src/components/page-header/page-header';
import * as p from 'src/constants/page-classnames';
import Description from 'src/components/description-block/description';
import VacancyFooter from './vacancy-detail-footer';
import QuizInfoModal from './quiz/quiz-info-modal';
import API from './api/api';
import css from './vacancy-detail.module.scss';
import { WORK_SEARCH } from 'src/constants/routes';
import { ReactComponent as LinkArrow } from 'src/assets/services-arrow-btn-2.svg';
import { QuizEntityType } from 'src/types/quiz';
import classNames from 'classnames';
import { useMetaContext } from 'src/hooks/meta-context';

function VacancyDetail() {
  const { slug } = useParams();
  const { updateMetaInfo } = useMetaContext();
  const [vacancy, setVacancy] = useVacancy(slug);
  const [showModal, setShowModal] = useState(false);
  const [open, setOpen] = useState(true);
  const [quizResult, setQuizResult] = useState(
    Cookies.get(slug) ? JSON.parse(Cookies.get(slug)) : Cookies.get(vacancy.id)
  );
  const [timer, setTimer] = useState(!quizResult?.isComplete ? quizResult - new Date().getTime() : 0);
  const mailDetails = `Відгук на вакансію "${vacancy.name}" від ${vacancy.unitName} від nazviazku.zsu.gov.ua`;
  const page = {
    path: WORK_SEARCH.path,
    title: WORK_SEARCH.title
  };

  const subject = encodeURI(mailDetails);

  const applyBtnHandler = (e) => {
    window.location.href = `mailto:${vacancy.email}?subject=${subject}&body=Доброго дня,`;
    e.preventDefault();
  };

  const handleSubmit = (data) => {
    setShowModal(false);
    if (data !== undefined) {
      const date = new Date();
      const result = data.isComplete ? data : date.setMinutes(date.getMinutes() + 15);
      setQuizResult(result);
      setTimer(result - new Date().getTime());
      Cookies.set(slug, data.isComplete ? JSON.stringify(result) : result);
      data.isComplete &&
        setVacancy((pre) => {
          return { ...pre, email: data.vacancyEmail };
        });
    }
  };

  const handleStartQuiz = () => setShowModal(true);

  const buttonCaption = () =>
    timer > 0
      ? `Тест буде повторно доступний через ${Math.floor((timer / (1000 * 60)) % 60)}:${Math.floor((timer / 1000) % 60)
          .toString()
          .padStart(2, '0')} хв.`
      : 'Пройти тест';

  updateMetaInfo({
    title: WORK_SEARCH.meta.title,
    description: WORK_SEARCH.meta.description,
    openGraph: {
      title: vacancy.name,
      description: `Доєднуйтесь у ${vacancy.unitName} на вакансію ${vacancy.name.toLowerCase()} `,
      img: vacancy.branchImg,
      type: 'website'
    }
  });

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        return setTimer(timer - 1000);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const quizDisabled = quizResult > new Date().getTime();
  return (
    <main className={css.vacancyDetailsPage}>
      <PageHeader className={p.WORK_SEARCH} title={vacancy.name} description={vacancy.unitName} pages={[page]} />
      <div className={css.body}>
        <div className={css.vacancyDetailsContainer}>
          <section className={css.vacancyDetails}>
            <h3 className={css.title}>Огляд</h3>
            <Description description={vacancy.shortDescription} />
            <Description description={vacancy.detailedDescription} />
          </section>
          <div className={css.info_block}>
            <section className={css.vacancyContact}>
              <h3>
                {vacancy.quizId && !quizResult?.isComplete
                  ? 'Щоб відгукнутись на вакансію, пройдіть тест'
                  : 'Для відгуку на вакансію надішли своє резюме на пошту'}
              </h3>
              {vacancy.quizId && !quizResult?.isComplete ? (
                <button
                  onClick={quizDisabled ? undefined : handleStartQuiz}
                  className={css.button}
                  disabled={quizDisabled}>
                  <p>{buttonCaption()}</p>
                  <LinkArrow className={css.arrow} />
                </button>
              ) : (
                <details open={open}>
                  <summary
                    onClick={(e) => {
                      e.preventDefault();
                      setOpen(() => !open);
                    }}
                    onKeyDown={(e) => {
                      e.preventDefault();
                      setOpen(() => !open);
                    }}
                    tabIndex={0}>
                    <span className={classNames(css.button, { [css.hide]: open })} disabled={quizDisabled}>
                      <p>{open ? 'Приховати контакти' : 'Податись на вакансію'}</p>
                      {!open && <LinkArrow className={css.arrow} />}
                    </span>
                  </summary>
                  <section className={css.materialsList}>
                    <VacancyFooter
                      email={quizResult?.vacancyEmail ?? vacancy.email}
                      mailDetails={mailDetails}
                      onSend={applyBtnHandler}
                    />
                  </section>
                </details>
              )}
            </section>
            <section className={css.unitInfo}>
              <h3>Про підрозділ</h3>
              <div className={css.group}>
                <img src={vacancy.unitImg} alt={vacancy.unitName} />
                <Description description={vacancy.unitDescription} />
              </div>
            </section>
          </div>
        </div>
      </div>
      {showModal && (
        <QuizInfoModal
          quizId={vacancy.quizId}
          entityId={vacancy.id}
          entityType={QuizEntityType.Work}
          onClose={handleSubmit}
        />
      )}
    </main>
  );
}

export default VacancyDetail;

const useVacancy = (slug) => {
  const [vacancy, setVacancy] = useState({
    branchImg: '',
    branchName: '',
    detailedDescription: '',
    email: '',
    hashtag: '',
    id: '',
    name: '',
    quizId: '',
    rankName: '',
    shortDescription: '',
    unitDescription: '',
    unitImg: '',
    unitName: ''
  });

  useEffect(() => {
    slug && API.getVacancy(slug).then(setVacancy);
  }, [slug]);
  return [vacancy, setVacancy];
};
